import { useEffect, useRef } from "react";

export function SalonReel({
  src,
  caption,
  captionsSrc,
}: {
  src: string;
  caption: string;
  captionsSrc: string;
}) {
  const ref = useRef<HTMLVideoElement>(null);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (!entry) return;
        if (entry.isIntersecting) {
          void el.play().catch(() => undefined);
        } else {
          el.pause();
        }
      },
      { rootMargin: "120px 0px" },
    );
    observer.observe(el);
    return () => observer.disconnect();
  }, []);

  return (
    <video
      ref={ref}
      src={src}
      muted
      loop
      playsInline
      preload="none"
      title={caption}
      className="aspect-[9/16] h-full w-full object-cover"
    >
      <track kind="captions" srcLang="en" label="English" src={captionsSrc} default />
    </video>
  );
}
